import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useI18n, type Language } from "@/lib/i18n";

type Props = { variant?: "compact" | "full"; className?: string };

export function LanguageSwitcher({ variant = "compact", className }: Props) {
  const { lang, setLang, t } = useI18n();
  return (
    <div className={className}>
      <Select value={lang} onValueChange={(v) => setLang(v as Language)}>
        <SelectTrigger
          className={variant === "compact" ? "h-9 w-[110px] text-sm" : "w-[160px]"}
          aria-label={t("lang.label")}
        >
          <SelectValue>{lang === "en" ? `${t("lang.en")} (EN)` : `${t("lang.es")} (ES)`}</SelectValue>
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="en">{t("lang.en")} (EN)</SelectItem>
          <SelectItem value="es">{t("lang.es")} (ES)</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
